<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body table-card">
                <div class="error-page">
                    <h3>Page introuvable</h3>
                    <img class="img-fluid" src="assets/illustrations/undraw_page_not_found_su7k.svg"><br/>
                    <p>
                        La page n'existe pas ou n'existe plus.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
